<header>
  <dx-toolbar class="header-toolbar">
    <dxi-item
      *ngIf="menuToggleEnabled"
      location="before"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }"
    >
    </dxi-item>
    <dxi-item
      location="before"
      cssClass="header-title"
      *ngIf="title"
      [text]="title"
    >
    </dxi-item>
    <!-- <dxi-item location="after" locateInMenu="never">
      <ng-container *dxTemplate>
        <theme-switcher></theme-switcher>
      </ng-container>
    </dxi-item> -->

    <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <user-panel
          [user]="user"
          [menuItems]="userMenuItems"
          menuMode="context"
        ></user-panel>
      </div>
    </dxi-item>
    <div *dxTemplate="let data of 'menuItem'">
      <user-panel
        [user]="user"
        [menuItems]="userMenuItems"
        menuMode="list"
      ></user-panel>
    </div>
  </dx-toolbar>
</header>
